@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.spacedWrapper {
  margin-bottom: 56px;
}

.alertWrapper {
  margin-bottom: variables.$std-margin-md;
}
